import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState='';

const openedDisbursementUri = createSlice({
  name: 'openedDisbursementUri',
  initialState,
  reducers: {
    setOpenedDisbursementUri(state,action:PayloadAction<string>){
        return (state = action.payload)
    }
  },

});

// Reducer
export default openedDisbursementUri.reducer;

// Actions
export const {setOpenedDisbursementUri} = openedDisbursementUri.actions;
